export default __webpack_public_path__ + "static/media/Screenshot (175).35929944.png";